import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3ba2153e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-title-card"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_c_title = _resolveComponent("c-title");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_title, _mergeProps({
    title: $props.title
  }, $props.titleprop), null, 16, ["title"]), _createElementVNode("div", {
    class: "list",
    style: _normalizeStyle({
      'grid-template-columns': $props.columns
    })
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item, index) => {
    return _openBlock(), _createBlock(_resolveDynamicComponent($props.name), _mergeProps({
      key: index,
      info: item
    }, $props.bindprop, {
      index: index
    }), null, 16, ["info", "index"]);
  }), 128))], 4)]);
}